import { OrderKeys } from '../OrderModule/data'

export const getELockModuleKey = (key: string) => `${OrderKeys.eLockModule}.${key}`
